import { useSchedulingLocationInfo } from './use-scheduling-location-info';

export const useCheckIsAutoMessagesEnabled = () => {
  const { getCFLocationMap } = useSchedulingLocationInfo();
  const autoMessagesCFLocationMap = getCFLocationMap('apptreminders-automated');
  const isAutoMessagesEnabledForAnyLocation = Object.values(autoMessagesCFLocationMap).some((value) => value);

  return { isAutoMessagesEnabled: isAutoMessagesEnabledForAnyLocation };
};
